(function($) {

	// Wait for document to get ready.
	$(document).ready(function() {

		//
		$("body").on('click', '.fancy-checkbox', function(e) {
			e.preventDefault();
			$(this).siblings('input').trigger('click');
		});

		//
		var fixCheckbox = function(checkbox) {

			// Mark element as fixed.
			$(checkbox).addClass("fancy-fixed");

			// Add fancy checkbox after real checkbox.
			$(checkbox).after('<span class="fancy-checkbox"></span>');
		};

		// Find all non fixed checkboxes/radios.
		$('input[type="checkbox"]:not(".fancy-fixed"), input[type="radio"]:not(".fancy-fixed")').each(function() {

			//
			fixCheckbox(this);
		});

		//
		var snippets = document.getElementsByTagName("softadmin-snippet");

		//
		if(!snippets.length) {

			// Exit.
			return;
		}

		// Create observer to find new checkboxes.
		var newCheckboxObserver = new MutationObserver(function(mutations) {

			// Loop over mutations.
			mutations.forEach(function(mutation) {

				// If nodes where added.
				if(mutation.addedNodes) {

					// Loop over each added node.
					for(var elementIndex in mutation.addedNodes) {
						//
						if(!mutation.addedNodes.hasOwnProperty(elementIndex)) {
							continue;
						}

						var element = mutation.addedNodes[elementIndex];

						//
						var $element = $(element);

						//
						$element.find('input[type="checkbox"]:not(".fancy-fixed"), input[type="radio"]:not(".fancy-fixed")')
							.each(function() {

								//
								fixCheckbox(this);
							});
					}
				}
			});
		});

		// Setup your configuration, this will watch to see if you insert or remove any children.
		var config = {
			subtree: true,
			childList: true
		};

		//
		for(var i in snippets) {

			//
			if(!snippets.hasOwnProperty(i)) {
				//
				continue;
			}

			//
			var snippet = snippets[i];

			// Start observing.
			newCheckboxObserver.observe(snippet, config);
		}


	});

})(window.jQuery);
